import { render, staticRenderFns } from "./DeliverySetting.vue?vue&type=template&id=192f0de7&scoped=true&"
import script from "./DeliverySetting.vue?vue&type=script&lang=js&"
export * from "./DeliverySetting.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySetting.vue?vue&type=style&index=0&id=192f0de7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192f0de7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDataTable,VForm,VSelect,VSpacer})
